import {
    createHandlerChainRunner,
    Handler,
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import validateAddress, { AddressErrors } from "@tSurya/Handlers/validateAddress";

type HandlerType = Handler<
    {
        shipTo: ShipToModel;
    },
    {
        isValid: boolean;
    }
>;

/**
 * Validates the currently selected ship-to address and updates the single
 * `isShippingAddressUpdateRequired` flag so the inline edit form shows whenever
 * the selected address is invalid - consistently on first selection and on reload.
 */
export const Validate: HandlerType = async props => {
    props.isValid = true;

    const { shipTo } = props.parameter;
    const addressFields = getAddressFieldsDataView(props.getState()).value;
    if (!shipTo.validation) {
        return;
    }
    if (!addressFields) {
        props.isValid = false;
        return;
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const addressErrors = await awaitableValidate({
        address: shipTo,
        validationRules: shipTo.validation,
        addressFieldDisplayCollection: addressFields.shipToAddressFields,
    })(props.dispatch, props.getState);

    props.isValid = Object.keys(addressErrors).length === 0;
};

export const DispatchIsShippingAddressUpdateRequired: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: !props.isValid,
    });
};

export const chain = [Validate, DispatchIsShippingAddressUpdateRequired];

const validateSelectedShippingAddress = createHandlerChainRunner(chain, "ValidateSelectedShippingAddress");
export default validateSelectedShippingAddress;
